push = (update) ->
  window.dataLayer?.push update

module.exports = {
  possibleNewSignup: ->
    push
      event: 'trello.possibleNewSignup'

  push
}



// WEBPACK FOOTER //
// ./app/scripts/debug/trackGoogleTagManager.coffee